import { Fullscreen } from "assets/icons/Common";
import styled from "styled-components";

import { IconButton, Row } from "./primitives";

interface Props {}

export const DashboardControls: React.FC<Props> = () => {
  return (
    <OuterContainer>
      <InnerContainer>
        <Spacer />
        <ControlButton
          Icon={Fullscreen}
          onClick={() =>
            document.fullscreenElement
              ? document.exitFullscreen()
              : document.body.requestFullscreen()
          }
        />
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  position: relative;
`;

const InnerContainer = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  gap: 15px;
  align-items: center;
  padding: 15px;
`;

const ControlButton = styled(IconButton)`
  width: 32px;
  height: 32px;
`;

const Spacer = styled.div`
  margin: 0 auto;
`;
